import { WalletOutlined } from '@ant-design/icons';
import { List, Row, Typography } from 'antd';
import CardWithIcon from 'components/new-ui/base/card/CardWithIcon';
import { StyledTotalsDiv } from 'views/invoices/settings/styles';
import TotalsListItem from './TotalsListItem';

export type TaxAmountsData = {
    net: number;
    tax: number;
    gross: number;
};

type Props = {
    data: TaxAmountsData;
    currencySymbol: string;
};

const TotalsSection = ({ data, currencySymbol }: Props) => {
    const { net, tax, gross } = data;

    return (
        <CardWithIcon
            gap="medium"
            layout="vertical"
            title="Totals"
            iconProps={{
                size: 32,
                borderRadius: 8,
                icon: <WalletOutlined />,
            }}
            children={
                <div>
                    <List>
                        <TotalsListItem label="Total Net Amount:" currencySymbol={currencySymbol} amount={net} />
                        <TotalsListItem label="Total Tax Amount:" currencySymbol={currencySymbol} amount={tax} />
                        <TotalsListItem label="Total Gross Amount:" currencySymbol={currencySymbol} amount={gross} />
                    </List>

                    <StyledTotalsDiv>
                        <Row justify="space-between" style={{ width: '100%' }}>
                            <Typography.Text>Total Due:</Typography.Text>
                            <Typography.Text>
                                {currencySymbol}
                                {gross.toFixed(2)}
                            </Typography.Text>
                        </Row>
                    </StyledTotalsDiv>
                </div>
            }
        />
    );
};

export default TotalsSection;
